// extracted by mini-css-extract-plugin
export var icon = "_64-1";
export var subtext = "_64-0";